import React from "react";

function About() {
  const expertise = [
    "GeoSpatial",
    "Multicloud",
    "Security",
    "AI",
    "Agile Transformation",
    "Middleware",
  ];

  return (
    <div
      id="about"
      style={{
        padding: "60px 20px",
        backgroundColor: "#f4f7fb",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div style={{ maxWidth: "1100px", margin: "0 auto", textAlign: "center" }}>
        {/* Section Title */}
        
        {/* Feature Cards */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "25px",
          }}
        >
          {/* Card 1 */}
          <div
            style={{
              background: "#fff",
              padding: "30px 20px",
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              transition: "transform 0.3s ease",
            }}
          >
            <h3
              style={{
                fontSize: "1.3rem",
                color: "#0d6efd",
                marginBottom: "15px",
              }}
            >
              Who we are
            </h3>
            <p style={{ color: "#555", lineHeight: "1.6", textAlign: "justify" }}>
              We are a team of Architects with a vision. In this dynamic world
              of technology, you need expertise as well as the ability to look
              into the future to ensure the best return on investment in terms
              of time and money. Our Architects are pioneers in this field, and
              our dedication and quality of service have helped us achieve a
              world-class position.
            </p>
          </div>

          {/* Card 2 */}
          <div
            style={{
              background: "#fff",
              padding: "30px 20px",
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              transition: "transform 0.3s ease",
            }}
          >
            <h3
              style={{
                fontSize: "1.3rem",
                color: "#0d6efd",
                marginBottom: "15px",
              }}
            >
              What we do
            </h3>
            <p style={{ color: "#555", lineHeight: "1.6", textAlign: "justify" }}>
              We envision at least a decade ahead in terms of excellent AI
              technologies. Based on this vision, we have architected our own AI
              tools and solutions, continuously improving them to stay aligned
              with market and client technologies. Our goal is to give peace of
              mind to our clients so they can focus on their business. We serve
              diverse domains including Telecom, Finance, Insurance, and Retail.
            </p>
          </div>

          {/* Card 3 */}
          <div
            style={{
              background: "#fff",
              padding: "30px 20px",
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              transition: "transform 0.3s ease",
            }}
          >
            <h3
              style={{
                fontSize: "1.3rem",
                color: "#0d6efd",
                marginBottom: "15px",
                textAlign: "center",
                fontWeight: "600",
              }}
            >
              Our Expertise
            </h3>

            <div
              style={{
                color: "#555",
                lineHeight: "1.8",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  display: "inline-block",
                  textAlign: "left",
                  marginBottom: "15px",
                }}
              >
                {expertise.map((item, index) => (
                  <p key={index} style={{ margin: "6px 0" }}>
                    <span
                      style={{
                        color: "#0d6efd",
                        fontWeight: "bold",
                        marginRight: "8px",
                      }}
                    >
                      {index + 1}.
                    </span>
                    {item}
                  </p>
                ))}
              </div>

              <p style={{ marginTop: "10px" }}>
                Empowering businesses to thrive through innovation and modern
                technology.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
